import { OrderDetailResolver } from './order-details/order-detail.resolver';
import { QuoteComponent } from './../order/quote.component';
import { CountriesResolver } from './../resolvers/countries.resolver';
import { BrandsResolver } from './../resolvers/brands.resolver';
import { OrderCompletedComponent, OrderCompletedGuard, QuoteCompletedGuard } from './../order/wizard/ordercompleted.component';
import { OrderSummaryComponent, OrderSummaryGuard } from './../order/wizard/ordersummary.component';
import { OrderShippingComponent, OrderShippingGuard } from './../order/wizard/ordershipping.component';
import { OrderBillingComponent, OrderBillingGuard } from './../order/wizard/orderbilling.component';
import { OrderAddressComponent, OrderAddressGuard } from './../order/wizard/orderaddress.component';
import { OrderPartComponent } from './../order/wizard/orderpart.component';
import { OrderComponent } from './../order/order.component';
import { RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AuthGuard } from '../authguard.service';
import { OrderDetailComponent } from './order-details/order-detail.component';
import { DashboardHomeComponent } from './home/dashboard-home.component';
var dahsboardRoutes = [
    { path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: '/dashboard/home', pathMatch: 'full', canActivate: [AuthGuard] },
            { path: 'home', component: DashboardHomeComponent, canActivate: [AuthGuard] /*   resolve: { orders: OrderResolver }*/ },
            {
                path: 'order',
                component: OrderComponent,
                children: [
                    { path: '', redirectTo: '/dashboard/order/part', pathMatch: 'full' },
                    { path: 'part', component: OrderPartComponent, resolve: { brands: BrandsResolver, countries: CountriesResolver } },
                    { path: 'address', component: OrderAddressComponent, resolve: { countries: CountriesResolver }, canActivate: [OrderAddressGuard] },
                    { path: 'billing', component: OrderBillingComponent, canActivate: [OrderBillingGuard] },
                    { path: 'shipping', component: OrderShippingComponent, canActivate: [OrderShippingGuard] },
                    { path: 'summary', component: OrderSummaryComponent, canActivate: [OrderSummaryGuard] },
                    { path: 'completed', component: OrderCompletedComponent, canActivate: [OrderCompletedGuard] },
                ]
            },
            { path: 'order/:id', component: OrderDetailComponent, resolve: { request: OrderDetailResolver }, canActivate: [AuthGuard] },
            {
                path: 'quote',
                component: QuoteComponent,
                children: [
                    { path: '', redirectTo: '/dashboard/quote/part', pathMatch: 'full' },
                    { path: 'part', component: OrderPartComponent, resolve: { brands: BrandsResolver, countries: CountriesResolver } },
                    { path: 'address', component: OrderAddressComponent, resolve: { countries: CountriesResolver }, canActivate: [OrderAddressGuard] },
                    { path: 'summary', component: OrderSummaryComponent, canActivate: [OrderSummaryGuard] },
                    { path: 'completed', component: OrderCompletedComponent, canActivate: [QuoteCompletedGuard] }
                ]
            },
        ],
    },
];
export var dashboardRouting = RouterModule.forChild(dahsboardRoutes);
//# sourceMappingURL=dashboard.routing.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.routing.js
// module id = 1155
// module chunks = 0